"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "venafro": {
    "69b3883c": [{
      "hkey": "f15abeb6",
      "slug": "la-madonnella-zona-industriale",
      "name": "La Madonnella-Zona Industriale",
      "primary": true,
      "skipSearch": false
    }],
    "la-madonnella": [{
      "hkey": "f15abeb6",
      "slug": "la-madonnella-zona-industriale",
      "name": "La Madonnella-Zona Industriale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;